/**
 * BRIXO - Global JavaScript
 * Core functionality for the theme
 */

// DOM Ready
document.addEventListener('DOMContentLoaded', function() {
  initCartDrawer();
  initHeaderScroll();
  initLazyLoading();
});

/**
 * Cart Drawer
 */
function initCartDrawer() {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  const cartCloseButtons = document.querySelectorAll('[data-cart-close]');
  
  if (!cartDrawer) return;
  
  // Open cart
  cartToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });
  
  // Close cart
  cartCloseButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      closeCartDrawer();
    });
  });
  
  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !cartDrawer.hidden) {
      closeCartDrawer();
    }
  });
}

function openCartDrawer() {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer) {
    cartDrawer.hidden = false;
    document.body.style.overflow = 'hidden';
  }
}

function closeCartDrawer() {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer) {
    cartDrawer.hidden = true;
    document.body.style.overflow = '';
  }
}

/**
 * Header Scroll Effect
 */
function initHeaderScroll() {
  const header = document.querySelector('[data-header]');
  if (!header) return;
  
  let lastScroll = 0;
  
  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll > 100) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    
    lastScroll = currentScroll;
  });
}

/**
 * Lazy Loading Images
 */
function initLazyLoading() {
  if ('loading' in HTMLImageElement.prototype) {
    // Browser supports native lazy loading
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
      }
    });
  } else {
    // Fallback to Intersection Observer
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
          }
          img.classList.add('is-loaded');
          observer.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  }
}

/**
 * Format Money
 */
function formatMoney(cents, format = '€{{amount_with_comma_separator}}') {
  const value = (cents / 100).toFixed(2);
  const [whole, decimal] = value.split('.');
  
  return format
    .replace('{{amount}}', value)
    .replace('{{amount_no_decimals}}', whole)
    .replace('{{amount_with_comma_separator}}', `${whole},${decimal}`)
    .replace('{{amount_no_decimals_with_comma_separator}}', whole);
}

/**
 * Debounce
 */
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/**
 * Fetch Cart
 */
async function fetchCart() {
  try {
    const response = await fetch('/cart.js');
    return await response.json();
  } catch (error) {
    console.error('Error fetching cart:', error);
    return null;
  }
}

/**
 * Update Cart Count
 */
function updateCartCount(count) {
  const countElements = document.querySelectorAll('[data-cart-count]');
  countElements.forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  });
}

// Export for use in other scripts
window.Brixo = {
  openCartDrawer,
  closeCartDrawer,
  formatMoney,
  debounce,
  fetchCart,
  updateCartCount
};







